export default "__VITE_ASSET__44Z36Ifm__"